import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/layouts/BottomNav';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaArrowLeft } from 'react-icons/fa';

const ContactDetailsPage = () => {
  const navigate = useNavigate();

  const locations = [
    {
      name: "ANDHERI",
      address: "Unit no.K, 27, New Link Rd, Laxmi Industrial Estate, Suresh Nagar, Andheri West, Mumbai, Maharashtra 400053"
    },
    {
      name: "LOWER PAREL",
      address: "Unit No. P-11, Raghuvanshi Mill Compound, Lower Parel, Mumbai, Maharashtra 400013"
    },
    {
      name: "HYDERABAD",
      address: "Vikas Plywood, 44, opposite Electric Substation, CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033"
    },
    {
      name: "NASHIK",
      address: "Ground Floor, Plot no.455, AAKAR SOCIETY, Gangapur College Link Road, opp. IDBI Bank, Thatte Nagar, Sahjeevan Colony, Nashik, Maharashtra 422005"
    },
    {
      name: "SURAT",
      address: "A/G-1, Ground Floor, Trade Centre, Bhatar Char Rasta, Bhatar, Althan, Surat, Gujarat 395017"
    }
  ];

  return (
    <div style={{ background: "#fafbfc", minHeight: "100vh", paddingBottom: 74 }}>
      {/* Header */}
      <div style={{
        display: "flex", alignItems: "center", padding: "18px 18px 10px 18px",
        borderBottom: "1px solid #f3f3f3", background: "#fff", position: "sticky", top: 0, zIndex: 10
      }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "none", border: "none", fontSize: 26, color: "#222",
            cursor: "pointer", lineHeight: 1, marginRight: 14
          }}
        >
          &larr;
        </button>
        <span style={{ fontWeight: 700, fontSize: 22, color: "#232323" }}>
          Contact Details
        </span>
      </div>

             {/* Hero Section */}
       <div style={{
         background: "#f8f9fa",
         padding: "32px 20px", textAlign: "center", borderBottom: "1px solid #e9ecef"
       }}>
         <div style={{ fontSize: 32, marginBottom: 12, color: "#6c757d" }}>
           📍
         </div>
         <h1 style={{
           fontSize: 24, fontWeight: 600, marginBottom: 8,
           color: "#333", letterSpacing: "0.3px"
         }}>
           EXPLORE OUR LOCATIONS
         </h1>
         <p style={{
           fontSize: 14, color: "#6c757d", lineHeight: 1.5,
           maxWidth: 400, margin: "0 auto"
         }}>
           Where Quality Meets Convenience!
         </p>
       </div>

      {/* Contact Info Cards */}
      <div style={{ padding: "24px 16px" }}>
        {/* General Contact */}
        <div style={{
          background: "#fff", borderRadius: 16, padding: 24,
          marginBottom: 24, boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
        }}>
          <h2 style={{
            fontSize: 20, fontWeight: 600, color: "#333",
            marginBottom: 20, textAlign: "center"
          }}>
            Get in Touch
          </h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 12,
              padding: "12px 16px", background: "#ffffff",
              borderRadius: 8, border: "1px solid #e9ecef"
            }}>
                             <div style={{
                 width: 40, height: 40, background: "#f8f9fa",
                 borderRadius: "50%", display: "flex", alignItems: "center",
                 justifyContent: "center", flexShrink: 0
               }}>
                 <FaPhone size={16} color="#6c757d" />
               </div>
              <div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 2 }}>
                  Phone
                </div>
                                 <div style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>
                   +91 80802 82228
                 </div>
              </div>
            </div>

            <div style={{
              display: "flex", alignItems: "center", gap: 12,
              padding: "12px 16px", background: "#ffffff",
              borderRadius: 8, border: "1px solid #e9ecef"
            }}>
                             <div style={{
                 width: 40, height: 40, background: "#f8f9fa",
                 borderRadius: "50%", display: "flex", alignItems: "center",
                 justifyContent: "center", flexShrink: 0
               }}>
                 <FaEnvelope size={16} color="#6c757d" />
               </div>
              <div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 2 }}>
                  Email
                </div>
                                 <div style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>
                   hello@venzowood.com
                 </div>
              </div>
            </div>
          </div>
        </div>

        {/* Locations */}
        <div style={{ marginBottom: 24 }}>
          <h2 style={{
            fontSize: 20, fontWeight: 600, color: "#333",
            marginBottom: 20, textAlign: "center"
          }}>
            Our Locations
          </h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {locations.map((location, index) => (
              <div
                key={index}
                style={{
                  background: "#fff", borderRadius: 8, padding: 16,
                  border: "1px solid #e9ecef", transition: "border-color 0.2s ease",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = "#6c757d";
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = "#e9ecef";
                }}
              >
                <div style={{
                  display: "flex", alignItems: "flex-start", gap: 16
                }}>
                  <div style={{
                    width: 40, height: 40, background: "#f8f9fa",
                    borderRadius: "50%", display: "flex", alignItems: "center",
                    justifyContent: "center", flexShrink: 0, marginTop: 4
                  }}>
                    <FaMapMarkerAlt size={16} color="#6c757d" />
                  </div>
                  
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontSize: 16, fontWeight: 600, color: "#333",
                      marginBottom: 6, letterSpacing: "0.3px"
                    }}>
                      {location.name}
                    </div>
                    <div style={{
                      fontSize: 13, color: "#6c757d", lineHeight: 1.5,
                      fontWeight: 400
                    }}>
                      {location.address}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Business Hours */}
        <div style={{
          background: "#fff", borderRadius: 16, padding: 24,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
        }}>
          <h2 style={{
            fontSize: 20, fontWeight: 600, color: "#333",
            marginBottom: 20, textAlign: "center"
          }}>
            Business Hours
          </h2>
          
          <div style={{
            display: "flex", flexDirection: "column", gap: 12
          }}>
            <div style={{
              display: "flex", justifyContent: "space-between",
              padding: "12px 0", borderBottom: "1px solid #f3f4f6"
            }}>
              <span style={{ fontSize: 15, color: "#6b7280" }}>Monday - Friday</span>
              <span style={{ fontSize: 15, fontWeight: 600, color: "#333" }}>9:00 AM - 6:00 PM</span>
            </div>
            <div style={{
              display: "flex", justifyContent: "space-between",
              padding: "12px 0", borderBottom: "1px solid #f3f4f6"
            }}>
              <span style={{ fontSize: 15, color: "#6b7280" }}>Saturday</span>
              <span style={{ fontSize: 15, fontWeight: 600, color: "#333" }}>9:00 AM - 4:00 PM</span>
            </div>
            <div style={{
              display: "flex", justifyContent: "space-between",
              padding: "12px 0"
            }}>
              <span style={{ fontSize: 15, color: "#6b7280" }}>Sunday</span>
              <span style={{ fontSize: 15, fontWeight: 600, color: "#333" }}>Closed</span>
            </div>
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default ContactDetailsPage;
